export const ChurnZeroConsts = {
  events: {
    login: 'Login',
    logout: 'Logout',
    draftSurveyCreated: 'Draft Survey Created',
    draftSurveyUpdated: 'Draft Survey Updated',
    lauchSurveyCreated: 'Launch Survey Created',
    surveyPaused: 'Survey paused',
    surveyClosed: 'Survey closed',
    acceptTos: 'Accepted Terms of Services',
    surveyLaunchedWithNoQuotas: 'Survey Launched With No Quotas',
    lastActive: 'Last Active',
  },
  eventDescriptions: {
    login: 'User Logged',
    logout: 'User Logged out',
    draftSurveyCreated: 'User created a survey (id :id)',
    draftSurveyUpdated: 'User updated a survey (id :id)',
    lauchSurveyCreated: 'Launch Survey Created (id :id)',
    surveyPaused: 'User paused a survey (id :id)',
    surveyClosed: 'User closed a survey (id :id)',
    acceptTos: 'User Accepted Terms of Services',
    surveyLaunchedWithNoQuotas: 'Survey Launched With No Quotas (id :id)',
    lastActive: 'User visited the dashboard',
  },
  fieldName: {
    hasAcceptedOptInCommunication: 'Hasacceptedoptincommunication',
  },
  contact: 'contact',
  AMlink: 'https://analytics.churnzero.net/churnzero.js',
  EUlink: 'https://eu1analytics.churnzero.net/churnzero.js',
  maxNumberConnAttempts: 3,
  connTimeOutMilliseconds: 3000,
};
